import * as React from 'react';
import { useContext } from 'react';

import { Typography } from '@mui/material';

import Button from '../ui/Button/Button';
import DialogActions from '../ui/DialogActions/DialogActions';
import DialogContent from '../ui/DialogContent/DialogContent';
import DialogContentText from '../ui/DialogContentText/DialogContentText';
import DialogTitle from '../ui/DialogTitle/DialogTitle';
import { ModalContext } from './ModalContext';
import { ModalContextModel } from './models/modal-context.model';
import { ModalDialogModel } from './models/modal-dialog.model';

export default function ModalDialog({
  content,
  title,
  extraButtons,
}: ModalDialogModel) {
  const ctx = useContext(ModalContext) as ModalContextModel;

  const handleClose = () => {
    ctx.modalStateHandler();
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>

        <DialogActions>
          {extraButtons}
          <Button className="dialog-btn dialog-btn-no" onClick={handleClose}>
            <Typography className="dialog-btn-no-text">No</Typography>
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  );
}
